export class PackageQuotationLine {
    packageCode: string;
    text?: string;
    price?: number;
    sortIndex?: number;
    tests?: any[];
    code?: string;
    isFavorite?: boolean;
    isSelected?: boolean;
    packageName?: string;
    isStructuringQuotationLine?: boolean;
    hideItem = false;
    executionNumber?:number;
}
